import { expectedValueKind, FilterColumnDef, FilterRow } from './types';

/**
 * 行が絞り込みに寄与するか。
 * 「値が空なら無効」だけでは、値入力を持たない empty / notEmpty が常に無効になる。
 * 有効判定は列の型と演算子の組で決まるため、件数表示・評価・プリセット保存は
 * すべてこの関数を共有すること（3 箇所で判定が食い違うのを防ぐ）。
 */
export function isActiveFilterRow(row: FilterRow, column: FilterColumnDef): boolean {
  if (row.value.kind !== expectedValueKind(column.type, row.operator)) return false;

  switch (row.value.kind) {
    case 'none':
      return true;
    case 'text':
      return row.value.value.trim() !== '';
    case 'number':
      return row.value.value !== null && Number.isFinite(row.value.value);
    case 'numberRange':
      return row.value.min !== null && row.value.max !== null
        && Number.isFinite(row.value.min) && Number.isFinite(row.value.max);
    case 'time':
      return /^([01]\d|2[0-3]):[0-5]\d$/.test(row.value.value);
    case 'enum':
      return row.value.values.length > 0;
    case 'id':
      return row.value.values.length > 0;
    case 'boolean':
      // null = 未選択のみ無効。false は「不可」で絞り込める有効値。
      return row.value.value !== null;
    default:
      return false;
  }
}
